import { pieceName } from './shopItems';

export const searchHaystack = (item) => {
    const { name, formatted } = pieceName(item, { shop: true });
    return [
        name,
        formatted,
        item.title,
        item.category,
        item.collection,
        item.collectionName,
        item.collectionJp,
        item.summary,
        item.detail,
        item.format,
        item.year,
        item.edition,
    ].filter(Boolean).join(' ').toLowerCase();
};

export const matchesQuery = (item, query) => {
    const words = String(query || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (!words.length) {
        return true;
    }
    const hay = searchHaystack(item);
    return words.every((word) => hay.includes(word));
};

export const searchCatalog = (items, query, limit = 12) => {
    const q = String(query || '').trim();
    if (!q) {
        return [];
    }
    return items.filter((item) => matchesQuery(item, q)).slice(0, limit);
};
